import * as React from 'react';
import { Navigate } from 'react-router-dom';
import { LOGIN_PATH, NO_PERMISSION_PATH } from '../../constants/paths.constants';
import { hasPermission } from '../../selectors/auth.selectors';

const PrivateRoute = ({
  component: Component,
  isPublic,
  access,
  user,
  isFetchingUser,
  isFetchedUser,
  permission,
  orPermissions,
  ...props
}) => {
  if (!isPublic && (!isFetchedUser || isFetchingUser)) {
    return null;
  }
  const hasReqiuredPermission = permission ? hasPermission(user, permission) : true;
  const hasOrPermission = orPermissions ? orPermissions.some((p) => hasPermission(user, p)) : true;
  const allowedAccess = hasReqiuredPermission && hasOrPermission;
  if (isPublic || (access && allowedAccess)) {
    return <Component {...props} />;
  }
  if (access) {
    return <Navigate to={NO_PERMISSION_PATH} />;
  }
  return <Navigate to={`${LOGIN_PATH}?fromUrl=${window.location.pathname}${window.location.search}`} />;
};

export default PrivateRoute;
